import styled from "styled-components";
import { SLForm } from "~/pages/Sistema/componentes/SistemaList";
import { Colors } from "~/config/Colors";

export const Container = styled(SLForm)`
  width: calc(100% - 0.8em);
  max-width: 100%;

  .padding-form {
    padding: 0 1em 1em 1em;
  }

  .row {
    margin-bottom: 0.5em;
  }

  .header {
    padding: 0 0.6em;
    margin-bottom: 1em;

    .h-titulo {
      font-size: 0.875em;
      color: ${Colors.ftColor3};
    }
    
    .h-descricao {
      font-size: 0.8125em;
      line-height: 0.8em;
      color: ${Colors.ftColor5};
    }
  }
`;
